import numeral from 'numeral';

export default function commaSeparate(num: number) {
	try {
		return numeral(num).format('0,0');
	} catch {
		return 0;
	}
}
